import r from "axios";
class $ {
  BASE_URL;
  constructor(t) {
    this.BASE_URL = t;
  }
  post(t, e = {}, s = {}) {
    return Object.keys(s).length === 0 ? r.post(`${this.BASE_URL}/${t}`, e) : r.post(`${this.BASE_URL}/${t}`, e, {
      headers: s
    });
  }
  put(t, e = {}) {
    return r.put(`${this.BASE_URL}/${t}`, e);
  }
  get(t, e = {}, s = {}) {
    const i = {
      params: e,
      headers: Object.keys(s).length ? s : void 0
    };
    return Object.keys(s).length && (i.headers = s), r.get(`${this.BASE_URL}/${t}`, i);
  }
  delete(t, e = {}) {
    return r.delete(`${this.BASE_URL}/${t}`, e);
  }
  patch(t, e = {}) {
    return r.patch(`${this.BASE_URL}/${t}`, e);
  }
}
export {
  $ as ApiResourceBaseClass
};
